import { __awaiter } from "tslib";
import { BaseService } from "@/servicesTs/base";
export class InterconsultService extends BaseService() {
    static get entity() {
        return "interconsult";
    }
    static get responseName() {
        return "interconsult";
    }
    static filterInterconsultsManagement(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter_interconsults_management`,
                data: payload,
            });
        });
    }
    static reportSicAuthorizedEgress(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `report_sic_authorized_egress`,
                data: payload,
                config: {
                    responseType: "blob",
                },
                showFullResponse: true,
            });
        });
    }
    static updateTeiState(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `update_tei_state`,
                data: payload,
            });
        });
    }
    static reportSicWithConsecutiveNsp(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `report_sic_consecutive_nsp`,
                data: payload,
                config: {
                    responseType: "blob",
                },
                showFullResponse: true,
            });
        });
    }
    static countInterconsultFilter(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `count_interconsults_filter`,
                data: payload,
                showFullResponse: true,
            });
        });
    }
    static exporttSicNoPertinences(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `export_sic_no_pertinences`,
                data: payload,
                config: {
                    responseType: "blob",
                },
                showFullResponse: true,
            });
        });
    }
}
